module.exports = __webpack_public_path__ + "static/img/statistics-empty-bright.3da60957.png";